const messages = {
  "ui.visibilitySelector.done": "Done",
  "ui.visibilitySelector.entireOrg": "Entire org",
  "ui.visibilitySelector.myTeam": "My team",
  "ui.visibilitySelector.onlyMe": "Only me",
  "ui.visibilitySelector.search.placeholder": "Search for teams",
  "ui.visibilitySelector.specificTeams": "Specific teams",
} as const;

export default messages;
